"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.222 5.04c1.075-.916 2.715-.141 2.715 1.26v11.4c0 1.402-1.639 2.176-2.715 1.26l-3.578-3.044H4.649A1.651 1.651 0 0 1 3 14.262V9.737c0-.91.736-1.653 1.649-1.653h1.995l3.578-3.044Zm1.315 1.26a.248.248 0 0 0-.407-.194L7.355 9.318a.7.7 0 0 1-.454.166H4.65a.251.251 0 0 0-.249.253v4.525a.25.25 0 0 0 .249.253H6.9a.7.7 0 0 1 .454.166l3.774 3.212a.248.248 0 0 0 .408-.194V6.3Zm2.989 1.536a.7.7 0 0 1 .966-.218c1.339.846 2.188 2.523 2.188 4.386s-.849 3.541-2.191 4.379a.7.7 0 0 1-.741-1.188c.862-.538 1.532-1.721 1.532-3.19 0-1.47-.67-2.656-1.536-3.203a.7.7 0 0 1-.218-.966Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M16.924 4.813a.7.7 0 0 1 .987-.073C19.8 6.368 21 9.03 21 12.002c0 2.97-1.198 5.63-3.083 7.257A.7.7 0 1 1 17 18.2c1.545-1.334 2.599-3.59 2.599-6.198 0-2.61-1.056-4.868-2.603-6.201a.7.7 0 0 1-.073-.988Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=MuteIcon24.js.map